<template>
  <div class="print">
    <p style="color: #303030">■ [별지 제1호서식]</p>
    <section>
      <div class="">
        <p class="print-title">사업주 안전·보건활동 현황</p>
        <div class="division-title">Ⅰ. 건설업체 개요</div>
        <table class="mt-2">
          <colgroup>
            <col width="60" />
            <col width="180" />
            <col />
            <col width="180" />
            <col />
          </colgroup>
          <tr>
            <th rowspan="3">본사</th>
            <th>①사업장명</th>
            <td class="text-left">{{ form.field && form.field.field_name ? form.field.field_name : "" }}</td>
            <th>②법인등록번호<br />(③사업자등록번호)</th>
            <td class="text-left">{{ form.사업자등록번호 }}</td>
          </tr>
          <tr>
            <th>대표자</th>
            <td class="text-left">{{ form.대표자 }}</td>
            <th>④사업장관리번호</th>
            <td class="text-left">{{ form.사업장관리번호 }}</td>
          </tr>
          <tr>
            <th>소재지</th>
            <td class="text-left">{{ form.소재지 }}</td>
            <th>시공능력평가순위</th>
            <td class="text-left">{{ form.시공능력평가순위 }}</td>
          </tr>
        </table>
      </div>
    </section>

    <section>
      <div class="division-title">Ⅱ. 전담 보건관리자 현황</div>
      <table class="mt-2">
        <colgroup>
          <col width="60" />
          <col />
          <col width="170" />
          <col />
          <col width="100" />
          <col width="60" />
          <col />
          <col width="60" />
        </colgroup>
        <tr>
          <th>연번</th>
          <th>현장명</th>
          <th>④사업개시번호</th>
          <th>공사금액<br/>(VAT 포함)</th>
          <th>성명</th>
          <th>성별</th>
          <th>⑤선임기간<br/>(평가기간 내 근무일수)</th>
          <th>정규직<br/>(O,X)</th>
        </tr>
        <tr>
          <td colspan="5" style="padding: 2px"></td>
        </tr>

        <tr v-for="(data, dataIndex) in form.전담보건관리자현황" :key="`${dataIndex}_${data.id}`">
          <td>{{ ++dataIndex }}</td>
          <td>{{ data.현장명 }}</td>
          <td>{{ data.사업개시번호 }}</td>
          <td>{{ comma(data.공사금액) }}</td>
          <td>{{ data.성명 }}</td>
          <td>{{ data.성별 }}</td>
          <td>{{ data.선임기간 }}</td>
          <td>{{ data.정규직 }}</td>
        </tr>
        <tr>
          <td colspan="5" style="padding: 2px"></td>
        </tr>
        <!--        합계 -->
        <tr>
          <th>합계</th>
          <th>⑥선임 의무<br/>전담 보건관리자 수</th>
          <th colspan="2">{{ `(&nbsp;&nbsp;&nbsp; ${form.전담보건관리자현황.length} &nbsp;&nbsp;&nbsp;) 명` }}</th>
          <th colspan="2">⑦정규직<br/>전담 보건관리자 수</th>
          <th colspan="2">{{ `(&nbsp;&nbsp;&nbsp; ${정규보건관리자} &nbsp;&nbsp;&nbsp;) 명` }}</th>
        </tr>
      </table>
    </section>

    <section>
      <div>
        <table class="mt-2">
          <tr>
            <td>
              <div class="flex gap-2">
                <span class="section-title">작성자 소속 및 성명 : </span>
                <span class="section-content">{{ form.stdInfo.department }} {{ form.stdInfo.writer_name }}</span>
              </div>

              <div class="flex gap-2">
                <span class="section-title">작성자 전화번호 : </span>
                <span class="section-content">{{ form.stdInfo.phone }}</span>
              </div>

              <div style="display: grid; grid-template-columns: 1fr 1fr">
                <div></div>
                <div class="flex gap-2 mt-4">
                  <span class="section-title">작성일</span>
                  <span class="section-content ml-4 mr-8" style="width: 150px;">{{ formatDate(form.stdInfo.date) }}</span>
                </div>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr">
                <div></div>
                <div class="flex gap-2" style="align-items: center;">
                  <span class="section-title">사업주</span>
                  <span class="section-content ml-4 mr-8" style="width: 150px;">{{ form.sign1.name }}</span>
                  <div style="position: relative; display: inline-block;">
                    <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100"/>
                    <span class="whitespace-no-wrap"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">(서명 또는 인)</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div class="w-full flex gap-2" style="border-bottom: 3px solid #757575; align-items: center; padding: 10px 0;">
          <span style="font-weight: 500; font-size: 27px;">한국산업안전보건공단 이사장</span>
          <span style="font-weight: 500; font-size: 18px;">귀하</span>
        </div>

        <table class="mt-2">
          <colgroup>
            <col width="160" />
            <col />
          </colgroup>
          <tr>
            <th>첨부서류</th>
            <td class="text-left">
              전담 보건관리자 선임보고서 사본 1부.<br/>
              근로계약서 1부.
            </td>
          </tr>
        </table>

        <table class="mt-2">
          <tr>
            <th class="etc-title">공지사항</th>
          </tr>
          <tr>
            <td class="etc-content">
              「건설업체의 산업재해예방활동 평가기준」 제13조의 규정에 따라 건설업체가 제출한 산업재해<br/>
              예방활동 실적에 대한 공단의 확인 결과, 허위로 판정된 경우 해당 지표의 평가점수를 0점 처리함
            </td>
          </tr>
        </table>

        <table class="mt-2">
          <tr>
            <th class="etc-title">작성방법</th>
          </tr>
          <tr>
            <td class="etc-content text-left">
              ① 사업장명: 도급인 사업장명을 적습니다.<br/>
              ② 법인등록번호: 법인 설립 시 등기소에서 부여하는 등기용 등록번호를 적습니다.<br/>
              ③ 사업자등록번호: 국세청에 등록된 도급인 사업장 사업자 등록번호를 적습니다.<br/>
              ④ 사업장관리번호(사업개시번호): 근로복지공단의 산업재해보상보험 가입 시 부여된 도급인 사업장 관리번호(사업개시번호)를 적습니다.<br/>
              ⑤ 선임기간: 고용노동부에 선임 신고된 날 ~ 종료일(예시 19.11.20.~20.10.5. 또는 19.11.20. ~)<br/>
              ⑥ 선임 의무 전담 보건관리자 수: 건설업체 소속 건설현장에서 평가기간 중 6개월 초과 근무한 전담 보건관리자 합산 수<br/>
              ⑦ 정규직 전담 보건관리자 수: 건설업체 소속 건설현장에서 평가기간 중 6개월 초과 근무한 정규직 전담 보건관리자 합산 수<br/>
            </td>
          </tr>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: { PrintCheckbox },

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
    header: Object,
  },

  computed: {
    formatDate() {
      return (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString; // 유효하지 않은 날짜면 원본 반환

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}년 ${month}월 ${day}일`;
      };
    },
    정규보건관리자() {
      return this.form.전담보건관리자현황.filter(item => item.정규직 === 'O').length;
    }
  },
  methods: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  }
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: bold;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 20px;
    font-weight: bold;
    color: #3c3c3c;
    padding-top: 1.25rem;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    border-top: 3px solid #757575;
    border-bottom: 3px solid #757575;
    border-left: none;
    border-right: none;

    th,
    td {
      border: 1px solid #757575;
      font-size: 18px;
      padding: 5px;
      text-align: center;

      &:first-child {
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
    }
    th {
      font-weight: 500;
    }
    td {
      font-weight: 400;
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
  }

  section {
    //page-break-inside: avoid;
    //page-break-after: auto;
  }

  .section-title {
    font-size: 18px;
    font-weight: 500;
  }
  .section-content {
    font-size: 18px;
    font-weight: 400;
  }
  .etc-title {
    background-color: #ececec;
    font-size: 24px;
    font-weight: 400;
    padding: 4px 0;
  }
  .etc-content {
    font-size: 20px;
    font-weight: 400;
    padding: 7px 0;
  }
}
</style>
